import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewAsProjectsComponent } from './view-as-projects.component';

const routes: Routes = [
  {
    path: '',
    component: ViewAsProjectsComponent,
    children: [
      {
        path: '',
        redirectTo: 'project'
      },
      {
        path: 'project',
        loadChildren: () => import('./view-as/view-as.module').then(mod => mod.ViewAsModule)
      },
      {
        path: 'project/assignment',
        loadChildren: () => import('./project-assignment/project-assignment.module').then(mod => mod.ProjectAssignmentModule)
      },
      {
        path: 'project/details',
        loadChildren: () => import('./project-details/project-details.module').then(mod => mod.ProjectDetailsModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewAsProjectsRoutingModule { }
